import { Table as ChakraTable } from "@chakra-ui/react";

export const Table = ChakraTable;
